class NmbrUpdatesDirectoryState {}

export default NmbrUpdatesDirectoryState;
